import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a commission report view.
 * @extends JetView
 */
export default class tableComissionReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Getting current user parameter

// Extending the webix data filter for summation in tree columns
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the summation display for a tree column.
                 * @param {Object} master - The master data view.
                 * @param {Object} node - The current node in the tree.
                 * @param {Object} value - The value object containing columnId.
                 */
                refresh: function(master, node, value) {
                    var result = 0; // Variable to hold the summation result
                    var resultFormat = 0; // Variable to hold formatted result
                    master.data.each(function(obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Summing values at level 1
                    });
                    // Formatting the result based on the column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Updating the node's inner HTML with the formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from the summColumn filter
        );

// Returning the configuration object for the tree table
        return {
            view: 'treetable', // Setting the view type to 'treetable'
            id: 'treetable', // Unique identifier for the tree table
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enabling row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling based on screen width
            columns: [
                {
                    id: 'TypeName', // Column ID
                    header: 'TypeName', // Column header
                    width: 200, // Column width
                    template: function(obj, common) {
                        // Template function to display TypeName or group value
                        if (obj.$group) return common.treetable(obj, common) + obj.value;
                        return obj.TypeName; // Return TypeName if not a group
                    },
                    footer: 'Total:', // Footer text
                },
                {
                    id: 'ActionTittle', // Column ID for actions
                    header: '', // No header text
                    width: 70, // Column width
                    height: 25, // Column height
                    tooltip: 'Acción', // Tooltip text for the column
                    template: function(obj) {
                        // Template function for action buttons based on state
                        if (obj.State == 'A' || obj.State == null) {
                            if (devConfig.getPermAction('comissionsReportBetShopApprove', 'Approve')) {
                                return '<span placeholder=\'Aprobar\' class=\'webix_icon wxi-close approve prm-comissionsReportBetShopApprove\'></span><span class=\'webix_icon icon-history torefuse prm-comissionsReportBetShopApprove\'></span>';
                            } else {
                                return ''; // No action if permission is not granted
                            }
                        } else {
                            if (obj.State == 'P' || obj.State == null) {
                                if (devConfig.getPermAction('comissionsReportBetShopPay', 'Pay')) {
                                    return '<span placeholder=\'Pagar\' class=\'webix_icon wxi-close pay prm-comissionsReportBetShopPay\'></span>';
                                } else {
                                    return ''; // No action if permission is not granted
                                }
                            } else {
                                return ''; // No action for other states
                            }
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 70, sort: 'int' }, // Column for ID
                {
                    id: 'ClientId', // Column for User ID
                    header: _('ID Usuario'), // Localized header
                    width: 95, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'ClientRef', // Column for User Reference
                    header: _('Usuario REF'), // Localized header
                    width: 95, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'CreatedLocal', // Column for creation date
                    header: _('Fecha de creación'), // Localized header
                    fillspace: 0, // No fill space
                    minWidth: 0, // Minimum width
                    width: 150, // Column width
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date formatting
                },
                {
                    id: 'CurrencyId', // Column for currency ID
                    header: _('Moneda'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'Bets', // Column for Bets
                    header: _('Apuestas'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Group delimiter for numbers
                        groupSize: 3, // Group size for numbers
                        decimalDelimiter: '.', // Decimal delimiter
                        decimalSize: 2, // Decimal size
                    }),
                    footer: { content: 'summTreeColumn' }, // Footer content
                    editor: 'text', // Editor type
                },
                {
                    id: 'Winnings', // Column for Winnings
                    header: _('Premios'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Group delimiter for numbers
                        groupSize: 3, // Group size for numbers
                        decimalDelimiter: '.', // Decimal delimiter
                        decimalSize: 2, // Decimal size
                    }),
                    footer: { content: 'summTreeColumn' }, // Footer content
                    editor: 'text', // Editor type
                },
                {
                    id: 'Bonus', // Column for Bonuses
                    header: _('Bonos'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Group delimiter for numbers
                        groupSize: 3, // Group size for numbers
                        decimalDelimiter: '.', // Decimal delimiter
                        decimalSize: 2, // Decimal size
                    }),
                    footer: { content: 'summTreeColumn' }, // Footer content
                    editor: 'text', // Editor type
                },
                {
                    id: 'AmountBase', // Column for Base Amount
                    header: _('Valor Base'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Group delimiter for numbers
                        groupSize: 3, // Group size for numbers
                        decimalDelimiter: '.', // Decimal delimiter
                        decimalSize: 2, // Decimal size
                    }),
                    footer: { content: 'summTreeColumn' }, // Footer content
                    editor: 'text', // Editor type
                },
                {
                    id: 'Amount', // Column for Commission Amount
                    header: _('Comision'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Group delimiter for numbers
                        groupSize: 3, // Group size for numbers
                        decimalDelimiter: '.', // Decimal delimiter
                        decimalSize: 2, // Decimal size
                    }),
                    footer: { content: 'summTreeColumn' }, // Footer content
                    editor: 'text', // Editor type
                },
                {
                    id: 'AmountPaid', // Column for Paid Amount
                    header: _('Valor Pagado'), // Localized header
                    width: 100, // Column width
                    sort: 'int', // Sorting type
                    format: webix.Number.numToStr({
                        groupDelimiter: ',', // Group delimiter for numbers
                        groupSize: 3, // Group size for numbers
                        decimalDelimiter: '.', // Decimal delimiter
                        decimalSize: 2, // Decimal size
                    }),
                    footer: { content: 'summTreeColumn' }, // Footer content
                    editor: 'text', // Editor type
                },
                {
                    id: 'State', // Column for State
                    header: _('Estado'), // Localized header
                    options: [
                        { id: '', value: _('None') }, // Option for no state
                        { id: 'A', value: _('Activo') }, // Option for active state
                        { id: 'I', value: _('Pagada') }, // Option for paid state
                        { id: 'P', value: _('Pendiente') }, // Option for pending state
                        { id: 'R', value: _('Rechazada') }, // Option for rejected state
                    ],
                },
                {
                    id: 'ModifiedLocal', // Column for last modified date
                    header: _('Modificado'), // Localized header
                    fillspace: 0, // No fill space
                    minWidth: 0, // Minimum width
                    width: 150, // Column width
                    sort: 'text', // Sorting type
                    format: dateFormat, // Date formatting
                },
            ],
            onClick: {
                /**
                 * Handles the click event for payment actions.
                 * @param {Event} euv - The event object.
                 * @param {String} id - The ID of the clicked item.
                 */
                pay: function(euv, id) {
                    var vthis = this; // Reference to the current context
                    webix
                        .modalbox({
                            title: _('Pregunta '), // Modal title
                            buttons: [
                                _('Efectivo'), // Button for cash payment
                                _('Saldo Recarga'), // Button for recharge balance
                                _('Saldo Juego'), // Button for game balance
                                _('Saldo Afiliados'), // Button for affiliate balance
                                _('Cancelar'), // Cancel button
                            ],
                            text: _('Seleccione el tipo de saldo '), // Modal text
                            width: 500, // Modal width
                        })
                        .then(function(result) {
                            switch (result) {
                                case '0': // Cash payment
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea pagar comisión en efectivo?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button
                                        cancel: _('Salir'), // Cancel button
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item by ID
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Setting content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for payment
                                                        '{ "Id":"' + item.Id + '", "Type":"0"}', // Payload for payment
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                data = JSON.parse(text); // Parsing response
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Updating item state to paid
                                                                    webix.message(_('Comisión Pagada')); // Success message
                                                                    webix
                                                                        .ui({
                                                                            view: 'window', // Creating a window for invoice
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: '$(\'windowfact2\').close();', // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // FileReader for reading PDF
                                                                    reader.onload = function(event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parsing the PDF data
                                                                        });
                                                                    };

                                                                    /**
                                                                     * Converts base64 data to a Blob object.
                                                                     * @param {String} b64Data - Base64 encoded data.
                                                                     * @param {String} contentType - MIME type of the data.
                                                                     * @param {Number} sliceSize - Size of each slice.
                                                                     * @returns {Blob} - The Blob object.
                                                                     */
                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || ''; // Default content type
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(b64Data); // Decoding base64
                                                                        var byteArrays = []; // Array to hold byte arrays
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            ); // Slicing the byte characters
                                                                            var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Getting char codes
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers); // Creating Uint8Array
                                                                            byteArrays.push(byteArray); // Pushing to byte arrays
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Creating Blob with content type
                                                                        });
                                                                        return blob; // Returning the Blob
                                                                    }

                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(b64Data, contentType); // Converting to Blob
                                                                    var file = window.URL.createObjectURL(blob); // Creating object URL
                                                                    console.log(blob); // Logging the Blob
                                                                    document.querySelector('iframe').src = file; // Setting iframe source to the Blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Opening print window
                                                                    );
                                                                    printWindow.print(); // Triggering print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '1': // Recharge balance payment
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo recargas?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button
                                        cancel: _('Salir'), // Cancel button
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item by ID
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Setting content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for payment
                                                        '{ "Id":"' + item.Id + '", "Type":"1"}', // Payload for payment
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                data = JSON.parse(text); // Parsing response
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Updating item state to paid
                                                                    webix.message(_('Comisión Pagada')); // Success message
                                                                    webix
                                                                        .ui({
                                                                            view: 'window', // Creating a window for invoice
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: '$(\'windowfact2\').close();', // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // FileReader for reading PDF
                                                                    reader.onload = function(event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parsing the PDF data
                                                                        });
                                                                    };

                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || ''; // Default content type
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(b64Data); // Decoding base64
                                                                        var byteArrays = []; // Array to hold byte arrays
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            ); // Slicing the byte characters
                                                                            var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Getting char codes
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers); // Creating Uint8Array
                                                                            byteArrays.push(byteArray); // Pushing to byte arrays
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Creating Blob with content type
                                                                        });
                                                                        return blob; // Returning the Blob
                                                                    }

                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(b64Data, contentType); // Converting to Blob
                                                                    var file = window.URL.createObjectURL(blob); // Creating object URL
                                                                    console.log(blob); // Logging the Blob
                                                                    document.querySelector('iframe').src = file; // Setting iframe source to the Blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Opening print window
                                                                    );
                                                                    printWindow.print(); // Triggering print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '2': // Game balance payment
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo juego?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button
                                        cancel: _('Salir'), // Cancel button
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item by ID
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Setting content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for payment
                                                        '{ "Id":"' + item.Id + '", "Type":"2"}', // Payload for payment
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! ')); // Error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                data = JSON.parse(text); // Parsing response
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Updating item state to paid
                                                                    webix.message(_('Comisión Pagada')); // Success message
                                                                    webix
                                                                        .ui({
                                                                            view: 'window', // Creating a window for invoice
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: '$(\'windowfact2\').close();', // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // FileReader for reading PDF
                                                                    reader.onload = function(event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parsing the PDF data
                                                                        });
                                                                    };

                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || ''; // Default content type
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(b64Data); // Decoding base64
                                                                        var byteArrays = []; // Array to hold byte arrays
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            ); // Slicing the byte characters
                                                                            var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Getting char codes
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers); // Creating Uint8Array
                                                                            byteArrays.push(byteArray); // Pushing to byte arrays
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Creating Blob with content type
                                                                        });
                                                                        return blob; // Returning the Blob
                                                                    }

                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(b64Data, contentType); // Converting to Blob
                                                                    var file = window.URL.createObjectURL(blob); // Creating object URL
                                                                    console.log(blob); // Logging the Blob
                                                                    document.querySelector('iframe').src = file; // Setting iframe source to the Blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Opening print window
                                                                    );
                                                                    printWindow.print(); // Triggering print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '3': // Affiliate balance payment
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo afiliados?'), // Confirmation text
                                        ok: _('Pagar Comisión'), // Confirm button
                                        cancel: _('Salir'), // Cancel button
                                        callback: function(action) {
                                            if (action === true) {
                                                var item = vthis.getItem(id); // Get the item by ID
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Setting content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisions', // API endpoint for payment
                                                        '{ "Id":"' + item.Id + '", "Type":"3"}', // Payload for payment
                                                        {
                                                            error: function(text, data, XmlHttpRequest) {
                                                                webix.message('Error! '); // Error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) {
                                                                data = JSON.parse(text); // Parsing response
                                                                if (!data.HasError) {
                                                                    item.State = 'I'; // Updating item state to paid
                                                                    webix.message(_('Comisión Pagada')); // Success message
                                                                    webix
                                                                        .ui({
                                                                            view: 'window', // Creating a window for invoice
                                                                            width: 500,
                                                                            height: 700,
                                                                            head: {
                                                                                view: 'toolbar',
                                                                                cols: [
                                                                                    {
                                                                                        view: 'label',
                                                                                        label: _('Factura'), // Invoice label
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        label: 'X', // Close button
                                                                                        width: 100,
                                                                                        align: 'right',
                                                                                        click: '$(\'windowfact2\').close();', // Close action
                                                                                    },
                                                                                ],
                                                                            },
                                                                            id: 'windowfact2', // Window ID
                                                                            modal: true, // Modal window
                                                                            position: 'center', // Center position
                                                                            body: {
                                                                                rows: [
                                                                                    {
                                                                                        template:
                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for PDF display
                                                                                    },
                                                                                ],
                                                                            },
                                                                        })
                                                                        .show(); // Show the window
                                                                    var reader = new FileReader(); // FileReader for reading PDF
                                                                    reader.onload = function(event) {
                                                                        $$('pdf').clear(); // Clear previous PDF
                                                                        $$('pdf').parse({
                                                                            data: event.target.result, // Parsing the PDF data
                                                                        });
                                                                    };

                                                                    function b64toBlob(
                                                                        b64Data,
                                                                        contentType,
                                                                        sliceSize,
                                                                    ) {
                                                                        contentType = contentType || ''; // Default content type
                                                                        sliceSize = sliceSize || 512; // Default slice size
                                                                        var byteCharacters = atob(b64Data); // Decoding base64
                                                                        var byteArrays = []; // Array to hold byte arrays
                                                                        for (
                                                                            var offset = 0;
                                                                            offset < byteCharacters.length;
                                                                            offset += sliceSize
                                                                        ) {
                                                                            var slice = byteCharacters.slice(
                                                                                offset,
                                                                                offset + sliceSize,
                                                                            ); // Slicing the byte characters
                                                                            var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                            for (var i = 0; i < slice.length; i++) {
                                                                                byteNumbers[i] = slice.charCodeAt(i); // Getting char codes
                                                                            }
                                                                            var byteArray = new Uint8Array(byteNumbers); // Creating Uint8Array
                                                                            byteArrays.push(byteArray); // Pushing to byte arrays
                                                                        }
                                                                        var blob = new Blob(byteArrays, {
                                                                            type: contentType, // Creating Blob with content type
                                                                        });
                                                                        return blob; // Returning the Blob
                                                                    }

                                                                    var contentType = 'application/pdf'; // PDF content type
                                                                    var b64Data = data.Pdf; // Base64 PDF data
                                                                    var blob = b64toBlob(b64Data, contentType); // Converting to Blob
                                                                    var file = window.URL.createObjectURL(blob); // Creating object URL
                                                                    console.log(blob); // Logging the Blob
                                                                    document.querySelector('iframe').src = file; // Setting iframe source to the Blob URL
                                                                    var printWindow = window.open(
                                                                        file,
                                                                        '',
                                                                        'width=800,height=500', // Opening print window
                                                                    );
                                                                    printWindow.print(); // Triggering print
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '4': // No action
                                    break;
                            }
                        });
                },
                /**
                 * Handles the click event for approving actions.
                 * @param {Event} euv - The event object.
                 * @param {String} id - The ID of the clicked item.
                 */
                approve: function(euv, id) {
                    var vthis = this; // Reference to the current context
                    webix.confirm({
                        type: 'confirm-warning',
                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Comisión'), // Confirmation text
                        ok: _('Aprobar Comisión'), // Confirm button
                        cancel: _('Salir'), // Cancel button
                        callback: function(action) {
                            if (action === true) {
                                var item = vthis.getItem(id); // Get the item by ID
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json', // Setting content type
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Commisions/ApproveComission', // API endpoint for approval
                                        '{ "Id":' + item.Id + '}', // Payload for approval
                                        {
                                            error: function(text, data, XmlHttpRequest) {
                                                webix.message(_('Error! ')); // Error message
                                            },
                                            success: function(text, data, XmlHttpRequest) {
                                                data = JSON.parse(text); // Parsing response
                                                if (!data.HasError) {
                                                    item.State = 'P'; // Updating item state to approved
                                                    webix.message(_('Comision Aprobado')); // Success message
                                                }
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
            },
            tooltip: true, // Enabling tooltips
            footer: true, // Enabling footer
            math: true, // Enabling math calculations
            loadahead: devConfig.getDefaultDataFetch(), // Preloading data configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/Financial/GetComissionsResume?FromId=' + cur_user + '&', // API endpoint for fetching commissions
        };
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Get the current user parameter, required for filtering
        const cur_user = this.getParam('user', true);
        // Define the URL for the grid data source
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Attach an event handler for when the grid data is loaded
        grid.attachEvent('onAfterLoad', function() {
            // Group the data in the tree table by 'TypeName' and aggregate specified fields
            $$('treetable').data.group({
                by: 'TypeName',
                map: {
                    AmountBase: ['AmountBase', 'sum'],
                    AmountPaid: ['AmountPaid', 'sum'],
                    Amount: ['Amount', 'sum'],
                    CurrencyId: ['CurrencyId'],
                },
            });
            // Group the data in the tree table by 'CurrencyId' and aggregate specified fields
            $$('treetable').data.group({
                by: 'CurrencyId',
                map: {
                    AmountBase: ['AmountBase', 'sum'],
                    AmountPaid: ['AmountPaid', 'sum'],
                    Amount: ['Amount', 'sum'],
                    CurrencyId: ['CurrencyId'],
                },
            });
        });
        // Listen for the 'depositReport:filter' event to apply filters to the grid
        this.on(this.app, 'depositReport:filter', (filterData) => {
            // Convert filter data object into an array of entries
            var object = Object.entries(filterData);
            var string1 = '';
            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the filter value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other filter parameters to the string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle nested object filters
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through nested filter entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Handle 'start' date filtering
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle 'end' date filtering
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the filter string
            string1 = string1 + '&FromId=' + cur_user;
            // Clear the grid data before loading new data
            grid.clearAll();
            // Load the grid data with the constructed URL and filter parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
        });
        // Attach an event handler for sorting the grid data
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Reload the grid data with the applied sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });
        // Attach an event handler for item clicks in the grid
        grid.attachEvent('onItemClick', function(id, e, node) {
            // Retrieve the clicked item based on its ID
            var item = this.getItem(id);
            // Trigger an event with the selected item's ID
            this.$scope.app.callEvent('deposit:id', [item.Id]);
        });
        // Listen for the 'player:select' event to load grid data based on selected player
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data for the selected player
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + user);
        }); // Placeholder for the initialization content of the view
    }
}

// FILE DOCUMENTED
